import axios from 'lib/utils/axios';

import createIdentificationRequest from 'api/requests/identification/createIdentification';

import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

async function fetchCountries({ commit }) {
  try {
    const { data } = await HTTPService.fetchIdentificationCountries();
    commit('SET_COUNTRIES', data);
  } catch (error) {
    logrocket.logger(error);
    commit('SET_COUNTRIES', []);
  }
}

async function fetchIdentification({ commit }) {
  try {
    const { data } = await HTTPService.fetchIdentification();
    commit('SET_IDENTIFICATION_STATUS', data.status);
  } catch (error) {
    logrocket.logger(error);
    commit('SET_IDENTIFICATION_STATUS', null);
  }
}

async function updateIdentification({ commit }, payload) {
  try {
    await HTTPService.updateIdentification(payload);

    const { data } = await HTTPService.fetchIdentification();
    commit('SET_IDENTIFICATION_STATUS', data.status);
  } catch (error) {
    logrocket.logger(error);
    commit('SET_IDENTIFICATION_STATUS', null);
  }
}

async function createIdentification({ commit }, payload) {
  try {
    const { data } = await createIdentificationRequest(axios, payload);

    commit('SET_IDENTIFICATION_STATUS', data.status);
  } catch (error) {
    commit('SET_IDENTIFICATION_STATUS', null);
    logrocket.logger(error);
    throw new Error;
  }
}

export default {
  fetchCountries,
  fetchIdentification,
  updateIdentification,
  createIdentification,
};
